import { Dimensions, Platform, StyleSheet } from 'react-native'

import { Fonts, Colors } from '@vfgroup-oneplatform/foundation/Components/Themes'

const styles = StyleSheet.create({
  container: {
    flex: 1,
  },
  startContainer: {
    height: '60%',
    paddingHorizontal: Platform.OS === 'web' && Dimensions.get('window').width > 700 ? '10%' : 16,
    paddingTop: 55,
    justifyContent: 'space-around',
  },
  closeIcon: {
    position: 'absolute',
    right: 20,
    top: 55,
  },
  title: {
    fontFamily: Fonts.type.VodafoneLt,
    fontSize: Fonts.size.h2,
    color: Colors.white,
    lineHeight: 38
  },
  cardsContainer: {
    flexDirection: 'row',
    justifyContent: 'space-between',
  },
  cardContainer: {
    alignItems: 'center',
  },
  simName: {
    ...Fonts.type.bold,
    fontSize: Fonts.size.h6,
    color: Colors.white,
    marginTop: 10,
  },
  bottomContainer: theme => ({
    backgroundColor: theme.colors.backgroundColorTwo,
    height: '40%',
    paddingHorizontal: Platform.OS === 'web' && Dimensions.get('window').width > 700 ? '10%' : 16,
    alignItems: 'center',
    justifyContent: 'space-between',
    paddingBottom: 25
  }),
  text: {
    fontFamily: Fonts.type.VodafoneLt,
    fontSize: Fonts.size.h5,
    textAlign: 'center',
    lineHeight: 32
  },
  textContainer: {
    flex: 1,
    alignItems: 'center',
    justifyContent: 'center',
  },
  button: {
    width: '100%',
  },
})

export default styles
